



















import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { formatCurrency } from '@getaccept/lib-shared/src/helpers/currency';
import type { Currency } from '@getaccept/lib-shared/src/types/Currency';
import MedalGold from '../../../assets/medal-gold.svg';
import MedalSilver from '../../../assets/medal-silver.svg';
import MedalBronze from '../../../assets/medal-bronze.svg';

export default defineComponent({
  name: 'TopPerformerBar',
  components: {
    MedalGold,
    MedalSilver,
    MedalBronze,
  },
  props: {
    value: {
      type: Number,
      default: 0,
    },
    currency: {
      type: Object as PropType<Currency>,
      default: null,
    },
    topValue: {
      type: Number,
      default: 0,
    },
    index: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const width = computed(() => {
      const width = Math.round((props.value / props.topValue) * 100);
      return `${width || 0}%`;
    });
    const formattedValue = computed(() => formatCurrency(props.value, props.currency));
    const topThree = computed(() => props.index < 3);

    return {
      width,
      formattedValue,
      topThree,
    };
  },
});
